import { useCallback } from "react";
import { useApiBase } from '../base/api-baixas-base'

export const usePutContato = () => {
    const { invocarApi, ...props } = useApiBase();

    const putContato = useCallback(
        (data) => {
            return invocarApi({
                url: `v1/Operacao/Contato/atualizar-contato`,
                method: 'PUT',
                headers: { "Content-Type": "application/json" },
                data: JSON.stringify(data),
                enviarTokenUsuario: false,
            })
        },
        [invocarApi],
    )
    return {
        putContato,
        ...props
    }
}
